import { render, staticRenderFns } from "./dsf-app-placeholder.vue?vue&type=template&id=580e69d6"
import script from "./dsf-app-placeholder.vue?vue&type=script&lang=js"
export * from "./dsf-app-placeholder.vue?vue&type=script&lang=js"
import style0 from "./dsf-app-placeholder.vue?vue&type=style&index=0&id=580e69d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports